import { createIcon } from "@chakra-ui/react";

export const Inline = createIcon({
  displayName: "EukaInline",
  viewBox: "0 0 666 290",
  path: [
    <path
      key="1"
      d="M259.308 68.3144H347.971V86.4833H279.843V126.181H334.938V144.35H279.843V188.392H350.144V206.562H259.308V68.3144Z"
      fill="currentColor"
    />,
    <path
      key="2"
      d="M511.83 158.965L499.39 170.42V206.562H480.039V65.353H499.39V146.721L542.635 107.024H567.517L525.654 145.931L571.269 206.562H547.571L511.83 158.965Z"
      fill="currentColor"
    />,
    <path
      key="3"
      d="M645.915 162.914V160.545H620.244C607.21 160.545 598.719 167.26 598.719 177.728C598.719 186.812 606.223 192.934 617.281 192.934C635.449 192.934 645.915 181.282 645.915 162.914ZM665.068 142.376V206.562H645.915V190.368C641.176 201.032 628.537 208.141 613.529 208.141C593.19 208.141 579.763 195.898 579.763 178.122C579.763 158.965 594.967 147.114 618.466 147.114H639.199C643.742 147.114 645.915 144.745 645.915 141.191C645.915 129.143 637.226 120.848 621.823 120.848C608.001 120.848 597.931 129.539 597.337 139.611H579.565C581.145 120.059 598.916 105.444 622.414 105.444C648.086 105.444 665.068 120.255 665.068 142.376Z"
      fill="currentColor"
    />,
    <path
      key="4"
      d="M259.169 236.366H284.504V240.044H263.146V254.999H280.647V258.677H263.146V277.903H259.169V236.366Z"
      fill="currentColor"
    />,
    <path
      key="5"
      d="M313.391 277.903H309.655V271.671C308.112 276.183 304.315 278.378 299.568 278.378C292.803 278.378 288.413 273.571 288.413 266.153V247.997H292.152V265.678C292.152 271.256 295.297 274.935 300.102 274.935C305.679 274.935 309.655 270.425 309.655 264.076V247.997H313.391V277.903Z"
      fill="currentColor"
    />,
    <path
      key="6"
      d="M328.572 238.206V247.997H338.064V251.437H328.572V268.943C328.572 272.383 330.529 274.461 333.556 274.461H338.064V277.902H333.615C328.216 277.902 324.833 274.461 324.833 268.943V251.437H318.427V247.997H324.833V238.206H328.572Z"
      fill="currentColor"
    />,
    <path
      key="7"
      d="M368.079 277.903H364.342V271.671C362.801 276.183 359.004 278.378 354.254 278.378C347.492 278.378 343.102 273.571 343.102 266.153V247.997H346.841V265.678C346.841 271.256 349.984 274.935 354.789 274.935C360.366 274.935 364.342 270.425 364.342 264.076V247.997H368.079V277.903Z"
      fill="currentColor"
    />,
    <path
      key="8"
      d="M388.421 251.437C381.836 251.437 380.116 257.49 380.116 265.146V277.904H376.376V247.997H380.116V254.347C381.302 250.192 383.792 247.997 388.421 247.997H392.336V251.437H388.421Z"
      fill="currentColor"
    />,
    <path
      key="9"
      d="M398.444 259.864H418.319C417.904 254.346 414.225 250.963 408.53 250.963C403.073 250.963 399.393 254.286 398.444 259.864ZM422.591 268.467C421.643 274.46 416.481 278.378 409.065 278.378C400.579 278.378 394.409 271.612 394.409 262.712C394.409 253.632 400.106 247.522 408.53 247.522C416.717 247.522 422.235 253.099 422.235 261.347C422.235 261.881 422.176 262.889 422.116 263.305H398.206C398.444 270.009 403.073 274.935 409.065 274.935C414.343 274.935 417.667 272.563 418.676 268.467H422.591Z"
      fill="currentColor"
    />,
    <path
      key="10"
      d="M443.996 236.366H447.972V274.223H469.271V277.903H443.996V236.366Z"
      fill="currentColor"
    />,
    <path
      key="11"
      d="M476.562 259.864H496.435C496.022 254.346 492.343 250.963 486.646 250.963C481.19 250.963 477.51 254.286 476.562 259.864ZM500.709 268.467C499.76 274.46 494.599 278.378 487.182 278.378C478.697 278.378 472.526 271.612 472.526 262.712C472.526 253.632 478.223 247.522 486.646 247.522C494.836 247.522 500.352 253.099 500.352 261.347C500.352 261.881 500.293 262.889 500.234 263.305H476.323C476.562 270.009 481.19 274.935 487.182 274.935C492.461 274.935 495.784 272.563 496.794 268.467H500.709Z"
      fill="currentColor"
    />,
    <path
      key="12"
      d="M526.984 264.077V263.188H517.907C512.923 263.188 509.719 265.56 509.719 269.358C509.719 272.74 512.39 274.936 516.541 274.936C523.127 274.936 526.984 270.96 526.984 264.077ZM530.721 258.617V277.903H526.984V272.444C525.203 276.062 521.05 278.379 516.245 278.379C509.836 278.379 505.744 274.875 505.744 269.358C505.744 263.662 510.489 260.04 517.907 260.04H525.144C526.449 260.04 526.984 259.507 526.984 258.617C526.984 254.108 523.781 250.964 518.204 250.964C513.576 250.964 509.659 253.871 509.42 257.372H505.684C506.277 251.617 511.972 247.521 518.204 247.521C526.034 247.521 530.721 251.972 530.721 258.617Z"
      fill="currentColor"
    />,
    <path
      key="13"
      d="M550.174 251.437C543.588 251.437 541.869 257.49 541.869 265.146V277.904H538.129V247.997H541.869V254.347C543.055 250.192 545.546 247.997 550.174 247.997H554.089V251.437H550.174Z"
      fill="currentColor"
    />,
    <path
      key="14"
      d="M559.423 247.997H563.162V254.226C564.703 249.717 568.5 247.522 573.247 247.522C580.009 247.522 584.4 252.328 584.4 259.746V277.903H580.663V260.219C580.663 254.641 577.52 250.965 572.713 250.965C567.136 250.965 563.162 255.472 563.162 261.821V277.903H559.423V247.997Z"
      fill="currentColor"
    />,
    <path
      key="15"
      d="M592.697 247.996H596.436V277.902H592.697V247.996ZM596.792 242.42H592.282V235.891H596.792V242.42Z"
      fill="currentColor"
    />,
    <path
      key="16"
      d="M604.739 247.997H608.477V254.226C610.019 249.717 613.816 247.522 618.562 247.522C625.325 247.522 629.716 252.328 629.716 259.746V277.903H625.979V260.219C625.979 254.641 622.835 250.965 618.029 250.965C612.452 250.965 608.477 255.472 608.477 261.821V277.903H604.739V247.997Z"
      fill="currentColor"
    />,
    <path
      key="17"
      d="M661.744 262.95C661.744 255.71 657.535 250.964 651.066 250.964C644.599 250.964 640.386 255.71 640.386 262.95C640.386 270.189 644.599 274.936 651.066 274.936C657.535 274.936 661.744 270.189 661.744 262.95ZM665.069 247.997V279.089C665.069 285.438 660.5 290.008 654.093 290.008H640.268V286.567H654.093C658.305 286.567 661.332 283.421 661.332 279.089V273.452C659.965 276.359 655.694 278.379 650.947 278.379C641.455 278.379 636.412 271.493 636.412 262.95C636.412 254.406 641.455 247.521 650.947 247.521C655.101 247.521 659.431 249.717 661.332 252.804V247.997H665.069Z"
      fill="currentColor"
    />,
    <path
      key="18"
      d="M412.291 208.139C443.612 208.139 454.747 189.679 454.747 165.677V143.772V107.024H435.591V164.495C435.591 180.295 426.311 189.541 412.291 189.541"
      fill="currentColor"
    />,
    <path
      key="19"
      d="M412.291 208.139C380.97 208.139 369.834 189.679 369.834 165.677V143.772V107.024H388.99V164.495C388.99 180.295 398.271 189.541 412.291 189.541"
      fill="currentColor"
    />,
    <path
      key="20"
      d="M102.52 265.132C104.082 245.749 112.381 227.736 126.282 213.833C140.19 199.923 158.212 191.622 177.605 190.068C174.367 229.972 142.434 261.894 102.52 265.132ZM14.053 190.07C53.9557 193.307 85.8805 225.227 89.1315 265.13C49.2185 261.893 17.2899 229.974 14.053 190.07ZM13.7819 12.8407H89.1572C86.0334 52.9748 53.9095 85.1016 13.7819 88.2247V12.8407ZM89.4051 183.376V224.134C85.3243 217.144 80.3315 210.625 74.4562 204.75C58.0584 188.347 36.7088 178.715 13.7819 177.193V101.57C56.0315 104.857 89.4051 140.293 89.4051 183.376ZM177.875 101.57V177.195C145.586 179.365 117.687 197.751 102.25 224.268V183.376C102.25 140.293 135.625 104.857 177.875 101.57ZM95.8276 149.12C86.1901 124.31 66.4192 104.536 41.6118 94.8972C77.0509 81.1256 102.25 46.6697 102.25 6.41737V-0.00594193H0.937012V88.4739V101.32V176.954V183.376C0.937012 235.687 43.5051 278.248 95.8276 278.248C148.15 278.248 190.719 235.688 190.719 183.376V176.952V88.4739H184.297C144.05 88.4739 109.597 113.675 95.8276 149.12Z"
      fill="currentColor"
    />,
    <path
      key="21"
      d="M122.369 -0.0061783V12.8404H177.875V68.3533H190.72V-0.0061783H122.369Z"
      fill="currentColor"
    />
  ],
  defaultProps: {
    "aria-label": "Euka logo",
    color: "text",
    w: "full",
    h: "full"
  }
});
